import { useState, useCallback, useEffect } from 'react';
import { visitsApi } from '../services/visitsApi';

export const useVisitRegistration = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [visitTypes, setVisitTypes] = useState([]);
  const [doctors, setDoctors] = useState([]);

  // Fetch visit types on mount
  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const [types, doctorsList] = await Promise.all([
          visitsApi.getVisitTypes(),
          visitsApi.getDoctors()
        ]);
        
        setVisitTypes(types);
        setDoctors(doctorsList);
      } catch (err) {
        console.error('Failed to fetch master data:', err);
      }
    };

    fetchMasterData();
  }, []);

  const searchPatients = useCallback(async (query) => {
    if (!query || query.length < 3) return [];
    try {
      const patients = await visitsApi.searchPatients(query);
      return patients;
    } catch (err) {
      setError(err.message || 'Failed to search patients');
      return [];
    }
  }, []);

  const registerVisit = useCallback(async (visitData) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const result = await visitsApi.createVisit(visitData);
      setSuccess(true);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to register visit');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const completeVisit = useCallback(async (visitId, vitalsData) => {
    setLoading(true);
    setError(null);
    try {
      const result = await visitsApi.completeVisit(visitId, vitalsData);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to complete visit');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    success,
    visitTypes,
    doctors,
    searchPatients,
    registerVisit,
    completeVisit,
  };
};